/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { confirmable, ConfirmDialog } from 'react-confirm';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
interface IConfirmDialogBodyProps {
    body: string;
}
export class ConfirmDialogProps {
    confirmation: string = "";
    options: IConfirmDialogBodyProps;
    constructor(confirmation?, options?) {
        this.confirmation = confirmation;
        this.options = options;
    }
}
const ConfirmModal: ConfirmDialog<ConfirmDialogProps, any> = (props) => {
    const { show, proceed, confirmation, options } = props;
    return (
        <Modal onHide={() => proceed(false)} show={show}>
            <Modal.Header>
                <Modal.Title>{confirmation}</Modal.Title>
            </Modal.Header>
            {
                options?.body ?
                    <Modal.Body>
                        {options.body}
                    </Modal.Body> : ""
            }
            <Modal.Footer>
                <Button variant="custom" onClick={() => proceed(true)}>Ок</Button>
                <Button variant="custom" onClick={() => proceed(false)}>Отмена</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default confirmable(ConfirmModal);


